export * from './components/SystemMessage/index';
//# sourceMappingURL=SystemMessage.js.map